export const localise = (value, intl, isHTML = false) =>
  isHTML
    ? intl.formatHTMLMessage({ id: value, defaultMessage: value })
    : intl.formatMessage({ id: value, defaultMessage: value });



// WEBPACK FOOTER //
// ./components/common/form-field/util.js